<template>
  <div class="product-intro">
    <page-header title="产品展示" subtitle="专注健康，品质保证" />
    <div class="product-intro-content">

      <!-- 产品一：三宝胶囊 -->
      <div class="product-card">
        <div class="product-card-inner">
          <div class="product-image-wrap">
            <img src="../assets/img/sanbao-jiaonang.png" alt="三宝胶囊" class="product-img" />
            <div class="product-badge">OTC 非处方药</div>
          </div>
          <div class="product-info">
            <div class="product-header">
              <h2 class="product-name">三宝胶囊</h2>
              <p class="product-subtitle">Sanbao Jiaonang</p>
              <span class="approval-code">国药准字 Z13020392</span>
            </div>
            <div class="info-section">
              <h4>【功能主治】</h4>
              <p>益肾填精，养心安神。用于心肾两虚所致头晕耳鸣、失眠健忘、腰膝酸软、体倦乏力。</p>
            </div>
            <div class="info-section">
              <h4>【主要成分】</h4>
              <p>鹿茸、人参、枸杞子等名贵中药材精制而成。</p>
            </div>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">剂　　型</span>
                <span class="value">胶囊剂</span>
              </div>
              <div class="info-item">
                <span class="label">规　　格</span>
                <span class="value">每粒 0.3g，10粒/盒</span>
              </div>
              <div class="info-item">
                <span class="label">注册分类</span>
                <span class="value">中药</span>
              </div>
              <div class="info-item">
                <span class="label">有 效 期</span>
                <span class="value">36个月</span>
              </div>
            </div>
            <div class="info-section manufacturer">
              <h4>【生产企业】</h4>
              <p>中美华医（河北）制药有限公司</p>
            </div>
            <div class="warning-box">
              <p>⚠ 请仔细阅读说明书并按说明使用或在药师指导下购买和使用</p>
            </div>
          </div>
        </div>
        <!-- 说明书 & 批件 -->
        <div class="doc-section">
          <h3 class="doc-section-title">资质文件</h3>
          <div class="doc-gallery">
            <div class="doc-item" @click="openLightbox(sanbaoImages, 0)">
              <div class="doc-img-wrap">
                <img src="../assets/img/sanbao-shuomingshu.png" alt="三宝胶囊说明书" />
                <div class="doc-overlay"><span>点击查看大图</span></div>
              </div>
              <p class="doc-label">药品说明书</p>
            </div>
            <div class="doc-item" @click="openLightbox(sanbaoImages, 1)">
              <div class="doc-img-wrap">
                <img src="../assets/img/sanbao-pijian.png" alt="药品注册批件" />
                <div class="doc-overlay"><span>点击查看大图</span></div>
              </div>
              <p class="doc-label">药品注册批件</p>
            </div>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <!-- 产品二：复方淫羊藿口服液 -->
      <div class="product-card reverse">
        <div class="product-card-inner">
          <div class="product-image-wrap">
            <img src="../assets/img/yinyanghuoke.png" alt="复方淫羊藿口服液" class="product-img" />
            <div class="product-badge">OTC 非处方药</div>
          </div>
          <div class="product-info">
            <div class="product-header">
              <h2 class="product-name">复方淫羊藿口服液</h2>
              <p class="product-subtitle">Fufang Yinyanghuoke Koufu Ye</p>
              <span class="approval-code">国药准字 B20020378</span>
            </div>
            <div class="info-section">
              <h4>【功能主治】</h4>
              <p>温肾壮阳。适用于肾阳虚衰所致畏寒肢冷、腰膝酸软、头晕目眩、气短喘急、倦怠乏力。</p>
            </div>
            <div class="info-section">
              <h4>【主要成分】</h4>
              <p>淫羊藿、熟地黄、山药、枸杞子、山萸肉、牡蛎、肉桂等。</p>
            </div>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">剂　　型</span>
                <span class="value">口服液（合剂）</span>
              </div>
              <div class="info-item">
                <span class="label">规　　格</span>
                <span class="value">每支 10ml，6支/盒</span>
              </div>
              <div class="info-item">
                <span class="label">注册分类</span>
                <span class="value">中药</span>
              </div>
              <div class="info-item">
                <span class="label">有 效 期</span>
                <span class="value">24个月</span>
              </div>
            </div>
            <div class="info-section manufacturer">
              <h4>【生产企业】</h4>
              <p>山东福牌制药有限公司</p>
            </div>
            <div class="warning-box">
              <p>⚠ 请仔细阅读说明书并按说明使用或在药师指导下购买和使用</p>
            </div>
          </div>
        </div>
        <!-- 说明书 & 注册证 -->
        <div class="doc-section">
          <h3 class="doc-section-title">资质文件</h3>
          <div class="doc-gallery">
            <div class="doc-item" @click="openLightbox(yinyangImages, 0)">
              <div class="doc-img-wrap">
                <img src="../assets/img/yinyanghuoke-shuomingshu.jpg" alt="复方淫羊藿口服液说明书" />
                <div class="doc-overlay"><span>点击查看大图</span></div>
              </div>
              <p class="doc-label">药品说明书</p>
            </div>
            <div class="doc-item" @click="openLightbox(yinyangImages, 1)">
              <div class="doc-img-wrap">
                <img src="../assets/img/yinyanghuoke-zhuchezheng.jpg" alt="药品再注册批准通知书" />
                <div class="doc-overlay"><span>点击查看大图</span></div>
              </div>
              <p class="doc-label">药品再注册批准通知书</p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 灯箱 Lightbox -->
    <div class="lightbox" v-if="lightbox.visible" @click.self="closeLightbox">
      <div class="lightbox-inner">
        <button class="lb-close" @click="closeLightbox">✕</button>
        <button class="lb-prev" @click="lbPrev" v-if="lightbox.images.length > 1">&#8249;</button>
        <img :src="lightbox.images[lightbox.index]" class="lb-img" />
        <button class="lb-next" @click="lbNext" v-if="lightbox.images.length > 1">&#8250;</button>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "../components/PageHeader";
export default {
  name: "ProductIntro",
  components: { PageHeader },
  data() {
    return {
      sanbaoImages: [
        require("../assets/img/sanbao-shuomingshu.png"),
        require("../assets/img/sanbao-pijian.png")
      ],
      yinyangImages: [
        require("../assets/img/yinyanghuoke-shuomingshu.jpg"),
        require("../assets/img/yinyanghuoke-zhuchezheng.jpg")
      ],
      lightbox: {
        visible: false,
        images: [],
        index: 0
      }
    };
  },
  methods: {
    openLightbox(images, index) {
      this.lightbox.images = images;
      this.lightbox.index = index;
      this.lightbox.visible = true;
    },
    closeLightbox() {
      this.lightbox.visible = false;
    },
    lbPrev() {
      this.lightbox.index = (this.lightbox.index - 1 + this.lightbox.images.length) % this.lightbox.images.length;
    },
    lbNext() {
      this.lightbox.index = (this.lightbox.index + 1) % this.lightbox.images.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-intro {
  width: 100%;
  background-color: #f5f8fc;
}

.product-intro-content {
  max-width: 1240px;
  margin: 0 auto;
  padding: 60px 20px;
}

// ── 产品卡片 ──────────────────────────────────────
.product-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin-bottom: 40px;

  &.reverse .product-card-inner {
    flex-direction: row-reverse;
  }
}

.product-card-inner {
  display: flex;
  align-items: stretch;
  min-height: 460px;
}

.product-image-wrap {
  position: relative;
  width: 380px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #f0f4f8 0%, #e8f0f8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;

  .product-img {
    max-width: 100%;
    max-height: 300px;
    object-fit: contain;
    filter: drop-shadow(0 8px 16px rgba(0,0,0,0.15));
    transition: transform 0.3s ease;
    &:hover { transform: scale(1.04); }
  }

  .product-badge {
    position: absolute;
    top: 20px;
    right: 20px;
    background: #e74c3c;
    color: white;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 4px;
    letter-spacing: 0.5px;
  }
}

.product-info {
  flex: 1;
  padding: 40px 50px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.product-header {
  border-bottom: 2px solid #e8f0f8;
  padding-bottom: 16px;

  .product-name {
    font-size: 32px;
    font-weight: 700;
    color: #14679f;
    margin-bottom: 4px;
  }
  .product-subtitle {
    font-size: 14px;
    color: #999;
    letter-spacing: 1px;
    margin-bottom: 10px;
  }
  .approval-code {
    display: inline-block;
    background: #e8f0f8;
    color: #14679f;
    font-size: 13px;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 4px;
    border: 1px solid #c2d9ef;
  }
}

.info-section {
  h4 {
    font-size: 14px;
    font-weight: 700;
    color: #333;
    margin-bottom: 6px;
  }
  p {
    font-size: 15px;
    color: #555;
    line-height: 1.8;
  }
  &.manufacturer p {
    color: #14679f;
    font-weight: 500;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  background: #f8fafc;
  border-radius: 6px;
  padding: 16px;

  .info-item {
    display: flex;
    align-items: center;
    gap: 8px;
    .label {
      font-size: 13px;
      color: #888;
      white-space: nowrap;
      font-weight: 500;
    }
    .value {
      font-size: 13px;
      color: #333;
      font-weight: 500;
    }
  }
}

.warning-box {
  background: #fffbf0;
  border: 1px solid #ffe58f;
  border-radius: 6px;
  padding: 10px 16px;
  margin-top: auto;
  p {
    font-size: 12px;
    color: #886a00;
    margin: 0;
  }
}

// ── 资质文件区域 ──────────────────────────────────
.doc-section {
  border-top: 1px solid #edf2f8;
  padding: 30px 40px 36px;
  background: #fafcff;
}

.doc-section-title {
  font-size: 16px;
  font-weight: 700;
  color: #14679f;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #14679f;
    border-radius: 2px;
  }
}

.doc-gallery {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.doc-item {
  cursor: pointer;
  text-align: center;

  .doc-img-wrap {
    position: relative;
    width: 200px;
    height: 260px;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid #dce8f5;
    background: #fff;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .doc-overlay {
      position: absolute;
      inset: 0;
      background: rgba(20, 103, 159, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.25s ease;

      span {
        color: #fff;
        font-size: 14px;
        font-weight: 500;
      }
    }

    &:hover img { transform: scale(1.05); }
    &:hover .doc-overlay { opacity: 1; }
  }

  .doc-label {
    margin-top: 10px;
    font-size: 13px;
    color: #555;
    font-weight: 500;
  }
}

// ── 分隔线 ────────────────────────────────────────
.divider {
  height: 1px;
  background: linear-gradient(to right, transparent, #dce8f5, transparent);
  margin: 10px 0 40px;
}

// ── 灯箱 Lightbox ────────────────────────────────
.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-inner {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 90vw;
  max-height: 90vh;
}

.lb-img {
  max-width: 80vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.5);
}

.lb-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
  padding: 4px 8px;
  &:hover { color: #aed6f1; }
}

.lb-prev,
.lb-next {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  font-size: 42px;
  line-height: 1;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 4px;
  transition: background 0.2s;
  flex-shrink: 0;
  &:hover { background: rgba(255,255,255,0.3); }
}
</style>
